<template>
    <div style="height: 100%">
        <v-card style="height: 100%" :class="{ 'overflow-auto': $vuetify.breakpoint.xsOnly }">
            <v-toolbar
                flat
                outlined
                v-if="gateway !== null"
                height="unset"
                class="py-2"
            >

                <v-toolbar-title class="ml-2">
                    <p class="subtitle-1 text-uppercase font-weight-bold ma-0 mb-n1 primary--text">
                        {{ gateway.name }}
                    </p>
                    <p class="caption ma-0 text-truncate" v-if="lastReadings && lastReadings.length">
                        Última lectura: {{ timeReading }}
                    </p>
                    <p v-else class="caption ma-0">Sin lecturas</p>
                </v-toolbar-title>

                <v-spacer></v-spacer>
                <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="mr-1"
                        >
                            <v-icon>
                                mdi-cog-outline
                            </v-icon>
                        </v-btn>
                    </template>
                    <v-list class="text-caption py-0" dense>
                        <v-list-item @click="editAction">Editar Planta</v-list-item>
                        <v-divider></v-divider>
                        <v-list-item @click="deletePlant">Eliminar Planta</v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar>
            <v-card-text class="" v-if="gateway">
                <v-toolbar flat outlined class="rounded-lg" dense @click="openMetersDialog" style="cursor: pointer">
                    Medidores
                    <v-spacer></v-spacer>
                    <v-avatar :color="colorIcon" size="22">
                        <v-icon dark small>
                            mdi-resistor
                        </v-icon>
                    </v-avatar>
                </v-toolbar>
                <v-img :src="gateway.url_img" max-height="130px" class="my-2 rounded-lg" />
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-toolbar flat outlined class="rounded-lg" dense v-bind="attrs" v-on="on">
                            {{ gateway.address && gateway.address.split(',')[0] }}
                            <v-spacer></v-spacer>
                            <v-icon>mdi-map-marker-circle</v-icon>
                        </v-toolbar>
                    </template>
                    <span>{{ gateway.address }}</span>
                </v-tooltip>
                
                <GmapMap
                    ref="map"
                    :center="{
                        lat: gateway.location.latitude,
                        lng: gateway.location.longitude,
                    }"
                    :zoom="17"
                    :options="{
                        zoomControl: false,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: false,
                        styles: [
                        {
                            featureType: 'poi.business',
                            stylers: [{ visibility: 'off' }],
                        },
                        {
                            featureType: 'transit',
                            elementType: 'labels.icon',
                            stylers: [{ visibility: 'off' }],
                        },
                        ]
                    }"
                    map-type-id="roadmap"
                    class="map my-2 rounded-lg"
                >

                    <GmapMarker
                        id="gateway.name"
                        v-if="gateway.location"
                        :position="{
                            lat: gateway.location.latitude,
                            lng: gateway.location.longitude,
                        }"
                        :icon="{ url: require('@/assets/map/icon.png') }"
                    />
                    
                </GmapMap>
                <v-toolbar flat outlined class="rounded-lg my-1 text-caption font-weight-bold" dense>
                    <span class="primary--text">Número de paneles:</span>
                    <v-spacer/>
                    {{ gateway.panels }}
                </v-toolbar>
                <v-toolbar flat outlined class="rounded-lg my-1 text-caption font-weight-bold" dense>
                    <span class="primary--text">Número de inversores:</span>
                    <v-spacer/>
                    {{ gateway.inverters }}
                </v-toolbar>
                <v-toolbar flat outlined class="rounded-lg my-1 text-caption font-weight-bold" dense>
                    <span class="primary--text">Tarifa:</span>
                    <v-spacer/>
                    {{ gateway.rate }}
                </v-toolbar>
            </v-card-text>
        </v-card>

        <MetersDialog 
            :open="MetersDialog.open"
            :meters="meters"
            :gateway_id="MetersDialog.gateway_id"
            :lastReadings="lastReadings"
            @close="closeMetersDialog"
        />

        <formGateway 
            :open="gtw_form.open" 
            @close="actionClose" 
            :id="gtw_form.id"/>

        <deleteGateway
            :open="delete_form.open"
            :id="delete_form.id"
            @close="closeDelete"/>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import formGateway from '../formGateway'
import deleteGateway from '../deleteGateway'
import MetersDialog from './meters.vue'

export default {
    name: 'info',
    props: ['gateway', 'meters', 'lastReadings'],
    components: { formGateway, deleteGateway, MetersDialog },
    computed: {
        ...mapState({
            minutesToWarn: state => state.account.profile.minutesToWarn,
            minutesToDanger: state => state.account.profile.minutesToDanger
        }),
        lastRead(){
            if(!this.lastReadings) return null
            if(this.lastReadings.length === 0) return null

            let last = null
            this.lastReadings.forEach( read => {
                if(last === null)
                    last = read
                if(last.data.updated.getTime() < read.data.updated.getTime() )
                    last = read
            });

            return last
        },
        timeReading(){
            if(!this.lastRead) return ''
            return this.lastRead.data.updated.toLocaleString()
        },
        colorIcon(){
            if(!this.lastRead) return 'blue-grey darken-1'
            
            const time = this.lastRead.data.updated.getTime()
            const diff = (new Date().getTime() - time) / (1000 * 60)
            
            if(diff > this.minutesToDanger) return 'red darken-3'
            else if(diff > this.minutesToWarn) return 'yellow accent-4'
            else return 'accent'
        }
    },
    data() {
        return {
            MetersDialog: {
                open: false,
                gateway_id: null
            },
            gtw_form: {
                open: false,
                id: null
            },
            delete_form:{
                open: false,
                id: null
            },
        }
    },
    methods: {
        openMetersDialog(){
            this.MetersDialog.gateway_id = this.gateway.id
            this.MetersDialog.open = true
        },
        closeMetersDialog(){
            this.MetersDialog.gateway_id = null
            this.MetersDialog.open = false
        },
        editAction(){
            this.gtw_form.open = true
            this.gtw_form.id = this.gateway.id
        },
        actionClose(){
            this.gtw_form.id = null
            this.gtw_form.open = false
        },
        deletePlant(){
            this.delete_form.id = this.gateway.id
            this.delete_form.open = true
        },
        closeDelete(){
            this.delete_form.id = null
            this.delete_form.open = false
        },
    },
}
</script>

<style scoped>
    .v-toolbar{
        height: unset;
    }
    .map{
        height: 200px;
        width: 100%;
        overflow: hidden;
    }
    .action-btn{
        position: absolute;
        bottom: 10px;
        left: 10px;
        right: 10px;
    }
</style>